var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.array !== undefined && _vm.array.length > 0
    ? _c(
        "div",
        { ref: "dropdown", staticClass: "minimalistic-dropdown rounded" },
        [
          _c(
            "div",
            {
              staticClass:
                "dropdown-button clickable d-flex align-items-center",
              on: {
                click: function ($event) {
                  return _vm.changeShowBox()
                },
              },
            },
            [
              _vm.selectedItem !== undefined
                ? _c("p", { staticClass: "font-weight-normal" }, [
                    _vm._v(_vm._s(_vm.selectedItem)),
                  ])
                : _vm._e(),
              _vm.showBox === false
                ? _c("b-icon", {
                    staticClass: "ml-1",
                    attrs: { icon: "chevron-down" },
                  })
                : _c("b-icon", {
                    staticClass: "ml-1",
                    attrs: { icon: "chevron-up" },
                  }),
            ],
            1
          ),
          _vm.showBox === true
            ? _c(
                "div",
                {
                  staticClass: "dropdown-box border position-absolute bg-white",
                },
                _vm._l(_vm.array, function (item, index) {
                  return _c(
                    "div",
                    {
                      key: index,
                      staticClass: "dopdown-item clickable px-3 py-2",
                      on: {
                        click: function ($event) {
                          return _vm.itemClicked(item)
                        },
                      },
                    },
                    [_vm._v(_vm._s(item.name || item))]
                  )
                }),
                0
              )
            : _vm._e(),
        ]
      )
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }